export default __webpack_public_path__ + "static/media/a40aed4748d43406158484d548cbad9c.png";